export default __webpack_public_path__ + "static/media/ebook-box-image-01.3aac56f8.png";